const initialState = {
    inProgressGetMakes: false,
    inProgressAddNewMake: false,
    items: [],
    error: null,
    selectedMake: {
        id: -1, name: "Make"
    }
};

const makesReducer = (state = initialState, action) => {

    if (action.type === 'SET_SELECTED_MAKE') {

        return {
            ...state,
            selectedMake: action.payload ?? initialState.selectedMake 
        }
    }

    if (action.type === 'GET_MAKES_STARTED') {

        return {
            ...state,
            inProgressGetMakes: true
        }
    }

    if (action.type === 'GET_MAKES_SUCCESS') {

        return {
            ...state,
            inProgressGetMakes: false,
            items: action.payload.items,
            error: null
        }

    }

    if (action.type === 'GET_MAKES_FAILURE') {

        return {
            ...state,
            loading: false,
            items: [],
            error: action.payload.error
        }
        
    }

    return state;

}

export default makesReducer;